import React, { useEffect } from "react";
import "./styles.css";
import SimpleSignComponent from "../../../components/signComponent/simpleSignComponent";
import { Grid } from "@mui/material";
import FormTextField from "../../../components/textField/formTextField";

const urlApi = process.env.REACT_APP_API_URL;

const SignSection = ({
  data,
  signature,
  setSignature,
  isComplete,
  control,
  errors,
  setValue,
  getValues,
  onSignatureChange
}) => {
  useEffect(() => {
    if (!data) return;

    const currentName = getValues("receivedByName");
    const currentPosition = getValues("receivedByPosition");
    const currentInstitution = getValues("institution");

    // Solo asigna si no hay valores actuales (evita pisar lo que ya está en el form)
    if (!signature && data.received_by_sign) {
      setSignature(data.received_by_sign);
    }

    if (!currentName && data.received_by_name) {
      setValue("receivedByName", data.received_by_name);
    }

    if (!currentPosition && data.received_by_position) {
      setValue("receivedByPosition", data.received_by_position);
    }

    if (!currentInstitution && data.institutionName) {
      setValue("institution", data.institutionName);
    }
  }, [data, setValue, setSignature, getValues]);

  return (
    <div className="engineering-report-signatures">
      <div className="HContainer">
        <div className="sign-container mr-5">
          <p className="createRist-title ml-0 mt-25">Realizado por</p>
          {data?.engineer_signature ? (
            <img
              src={`${urlApi}/${data?.engineer_signature}`}
              style={{
                width: "100%",
                objectFit: "contain"
              }}
              disabled
            />
          ) : (
            <div className="sign-box">Firma Electrónica</div>
          )}

          <div className="sign-info">
            <p className="info-label">
              Nombre:{" "}
              <span className="info-label-data">{data?.made_by_user_name}</span>
            </p>

            <p className="info-label">
              Cargo:{" "}
              <span className="info-label-data ">{data?.made_by_position}</span>
            </p>
            <p className="info-label">
              Inscripción de recurso humano:{" "}<span className="info-label-data ">{data?.made_by_rh}</span>{" "}
            </p>
          </div>
        </div>

        <div className="sign-container ml-5">
          <p className="createRist-title ml-0 mt-25">Recibido por</p>
          <SimpleSignComponent
            setSignature={onSignatureChange}
            signature={signature}
            hideButtons={isComplete}
            captureOnStrokeEnd
            clearWithIcon
            hideSave
            disabled={isComplete}
          />
          <div className="sign-info">
            <p className="info-label">Nombre:</p>
            <Grid item xs={6}>
              <FormTextField
                name="receivedByName"
                control={control}
                label=""
                error={errors.newActivity}
                margin={"0"}
                disabled={isComplete}
              />
            </Grid>
            <p className="info-label">Cargo:</p>
            <Grid item xs={6}>
              <FormTextField
                name="receivedByPosition"
                control={control}
                label=""
                error={errors.newActivity}
                margin={"0"}
                disabled={isComplete}
              />
            </Grid>
            <p className="info-label">Institución:</p>
            <Grid item xs={6}>
              <FormTextField
                name="institution"
                control={control}
                label=""
                disabled
                margin={"0"}
              />
            </Grid>
          </div>
        </div>
      </div>

    </div>
  );
};

export default SignSection;
